import { Component, OnInit , OnDestroy , ViewChild, Inject  } from '@angular/core';
import {Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { MatDialog , MatDialogRef , MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServerService } from '../../service/server/server.service';

@Component({
  selector: 'app-sale-attachment',
  templateUrl: './sale-attachment.component.html',
  styleUrls: ['./sale-attachment.component.css']
})
export class SaleAttachmentComponent implements OnInit , OnDestroy {
  public isOnline:any;
  public loading = false;
  public subscription:Subscription;
  public err:string;public err_validation:boolean=false;
  public err_internet_text:string;public err_internet_validation:boolean;
  public server:any;
  public username:any;
  public id:any;
  public factor:any;
  public list_load_file:any=[];
  public confirm_delete:any;
  public config:any;
  request_status_number:number;

  
  constructor(public serverService:ServerService , public router:Router , @Inject(MAT_DIALOG_DATA) public dialog_data:any ,
  public dialogRef:MatDialogRef<SaleAttachmentComponent>) { 
   this.id = this.dialog_data.id;
   this.factor = this.dialog_data.factor;
  }//end consructor
  
  ngOnInit() {
   this.server = localStorage.getItem("server");
   this.load_file();
  }

  load_file(){
    $(document).ready(function(){
     $(".dz-complete").remove();   
    });
    this.subscription = this.serverService.post_address(this.server,'sales_load_file',{'factor':this.factor}).subscribe(   
     (res) => {
      this.list_load_file=[];  
        for(var i=0;i<res['num'];i++){
         this.list_load_file.push(res['result'][i]);   
        }//end for
      }
     )  
   }//end load_file

   delete_file(id){ 
    this.confirm_delete = confirm("آیا شما از حدف اطمینان دارید ؟");
    if(this.confirm_delete == true){
     this.loading=true; 
     this.subscription = this.serverService.post_address(this.server,'sales_file_delete',{"username" : this.username , 'id' : id , 'factor' : this.factor }).subscribe(    
      (res)=>{
       if(res['status'] == 1 ){
        this.list_load_file=[];
        for(var i=0;i<res['num'];i++){
         this.list_load_file.push(res['result'][i]);   
        }//end for
        this.recieve_erorr(false,false,"","",1);
       }//end if this.data['status'] == 1
       else{
        this.recieve_erorr(true,true,'Erorr in delete',"خطا در حذف",1);
       }//end else
      }//end res
     )//end
    }//end this.confirm_delete == true  
   }//end delete_file

   close(){
    this.dialogRef.close();
   }
  //**************************************************
  recieve_erorr(err_validation,loading,en_message,pe_message,type){
   this.err_validation=err_validation; 
   if(type == 1 ) this.loading=false; 
   this.err=pe_message;
  }//end 
  //*******************************************************************************
  ngOnDestroy():void{
   if(this.subscription){
    this.subscription.unsubscribe();
   }//end if
  }//end OnDestroy
}

